import "./Iso-Certification.css";
import Footer from "../../components/Footer/index.js";
import ContactModal from "../../components/ConsultationModal/index.js";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const IsoCertification = () => {
  const { slug } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [course, setCourse] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const cleanHTML = (text) => {
    if (!text) return "";

    return text
      .replace(/<(?!\/?(b|strong)\b)[^>]*>/gi, "") // keep <b>, <strong>
      .replace(/&nbsp;/g, " ");
  };

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const decodedISO = decodeURIComponent(slug);

        console.log("Slug:", slug);
        console.log("Decoded:", decodedISO);

        const res = await fetch(
          `${BASE_URL}course/${decodedISO}`
        );

        const data = await res.json();

        console.log("API Response course detils:", data);

        if (data.success) {
          setCourse(data.data);
        } else {
          setCourse("no-data");
        }
      } catch (err) {
        console.error(err);
        setCourse("error");
      }
    };

    fetchCourse();
  }, [slug]);
  if (course === null) {
    return <h6 style={{ textAlign: "center" }}>Loading...</h6>;
  }

  if (course === "no-data" || course === "error") {
    return <h6 style={{ textAlign: "center" }}>No Data Found</h6>;
  }
  return (
    <div>
      <section className="iso-hero-section">
        <div className="iso-hero-container">
          <div className="iso-hero-content">
            <span className="iso-hero-badge">{course.category}</span>

            <h1 className="iso-hero-title">
              {course.standard}{" "}
              <span className="iso-hero-highlight">Certification</span>
            </h1>

            <p dangerouslySetInnerHTML={{
              __html:
                course.short_description
            }}
            />


            {/* <p >{course.short_description}</p> */}

            <div className="iso-hero-buttons">
              <button
                onClick={() => setShowModal(true)}
                className="iso-hero-btn-primary"
              >
                Enquiry Now
              </button>
            </div>
          </div>

          <div className="iso-hero-image-wrapper">
            {/* <img src={course.image1} alt="ISO Office" className="iso-hero-image" /> */}
            <img
              src={course.image1 || ""}
              alt="ISO Office"
              className="iso-hero-image"
              style={{ display: course.image1 ? "block" : "none" }}
            />
          </div>
        </div>
      </section>

      <section className="iso-about-main">
        <div className="iso-about-wrapper">
          <div className="iso-about-left">
            {/* <img src={course.image2} alt="ISO Office" /> */}
            <img
              src={course.image2 || ""}
              alt="ISO Office"
              style={{ display: course.image2 ? "block" : "none" }}
            />
          </div>

          <div className="iso-about-right">
            <span className="iso-about-tag">About {course.standard}</span>

            <h2 className="iso-about-title">Why {course.standard} Matters</h2>

            <p dangerouslySetInnerHTML={{
              __html:
                course.long_description
            }}
            />




          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">

              {course.benefits?.length > 0 && (
                <div class="mt-4">
                  <div class="d-flex align-items-center">
                    <h3 className="iso-about-subtitle">Benefits</h3>
                  </div>
                  <div className="row mt-3">
                    {course.benefits.map((item, i) => (
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="iso-feature-item benefit-b" key={i}>
                          ✔ {item}
                        </div>

                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-6 mt-4">
              <h3 className="iso-about-subtitle">
                Key Features of {course.standard}
              </h3>

              <div className="iso-feature-grid mt-4">
                {course.key_features?.map((item, i) => (
                  <div className="iso-feature-item" key={i}>
                    ✔ {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div class="container mt-5">
          <div className="iso-why-card">
            <h4>Why Choose Us?</h4>
            <p dangerouslySetInnerHTML={{
              __html:
                course.why_choose
            }}
            />
          </div>
        </div>
      </section>

      {course.key_features?.length > 0 && (
        <section className="features-section">
          <div className="features-container">
            <h2 className="features-title">Key Features</h2>

            <div className="features-grid">
              {course.key_features.map((item, i) => {
                const title = typeof item === "string" ? item : item.title;

                const icon =
                  typeof item === "object" && item.icon
                    ? item.icon
                    : "https://cdn-icons-png.flaticon.com/512/190/190411.png";

                return (
                  <div key={i} className="feature-card">
                    <img src={icon} alt="icon" className="feature-icon" />
                    <p>{title}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}


      <section className="iso-process-section">
        <div className="iso-process-container">
          <div className="iso-process-header">
            <h2 className="iso-process-title">Our Certification Process</h2>
          </div>

          <div className="iso-process-grid">
            {course.certification_process?.map((step, i) => (
              <div className="iso-process-card" key={i}>
                <div className="iso-process-number">{i + 1}</div>
                <h3>{step.title}</h3>
                <p>{step.content}</p>
              </div>
            ))}
          </div>
        </div>

        <ContactModal show={showModal} onClose={() => setShowModal(false)} />
      </section>

      <Footer />
    </div>
  );
};

export default IsoCertification;
